/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextFocusMonitorImplIphoneSafari13
 * @extends com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari12
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari13 = function () {
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari13.__super__.call(this);
};

// The extend defines the __super__
$hxClasses.extend(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari12,
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari13,
	"com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari13");

/**
 * onFocus - Handler for focus events on the chat interface's text input area.
 * Note: 
 * This has been overriden from the base implementation to allow a slight 
 * delay so any IOS animations have time to finish before we do 
 * onFocus tasks (like resize).
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari13.prototype.onFocus = function(ev, element) {
	// Added slight delay to allow window size changes to occur before we do anything
	com.inq.utils.Timer.delay(function () {
		com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.onFocus.call(this, ev, element);
		com.inq.flash.client.chatskins.ScrollMonitor.ScrollBy(0, 1);
	}.bind(this), this.CONST.RESIZE_DELAY_MS_IPHONE_13);
};

/**
 * Returns viewable area excluding virtual on-screen keyboard.
 * This includes logic to account for skin 'fixes', edge-cases, and calling a fallback implementation if required.
 * @returns {number} the viewable height, excluding on-screen keyboard
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari13.prototype.calculateViewableArea = function () {
	/** @type {(Object|undefined)} */
	var visualViewport = com.inq.utils.Util.getVisualViewport();

	// Fallback to our previous method of calculating height in case visualViewport is not implemented in browser
	if (com.inq.utils.Util.isNullOrUndefined(visualViewport)) {
		return this._calculateViewableAreaParentImplementation();
	}

	this.calculateIOSGapFixHeight();

	if (this._isFirstFocusOnElement()) {
		this._removeFirstFocusAttribute();
		return this._getFullScreenHeight();
	}

	if (this._inputTypeHasNoKeyboard() || this._isIPhoneWebViewSmallViewport()) {
		return this._getFullScreenHeight();
	}

	return this._getViewableHeight();
};

/**
 * Call our iOS 7 implementation of calculateViewableArea for when we need to fallback on it when the browser's
 * VisualViewport API is not implemented.
 * @returns {number}
 * @private
 * @see {com.inq.utils.Util.getVisualViewport}
 * @see {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7#calculateViewableArea}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari13.prototype._calculateViewableAreaParentImplementation = function () {
	var thisPrototype = Object.getPrototypeOf(this);
	var parentPrototype = Object.getPrototypeOf(thisPrototype);

	return parentPrototype.calculateViewableArea.call(this);
};

/**
 * Edge case scenario when calculating viewable area
 * @returns {boolean}
 * @private
 * @see {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari13#calculateViewableArea}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari13.prototype._isIPhoneWebViewSmallViewport = function () {
	var isPortrait = com.inq.utils.Capabilities.getOrientation();
	var isIOSWebView = com.inq.utils.Capabilities.isIOSWebView();
	var isSmallViewPort = this._getViewableHeight() < Application.minHeight;

	return isPortrait && isIOSWebView && isSmallViewPort;
};

/**
 * Gives us the viewable height of the screen, excluding the virtual on-screen keyboard.
 * We are accounting for iOSGapFixHeight to be backwards compatible with our skins.
 * @returns {number}
 * @private
 * @see {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari13#calculateViewableArea}
 * @see {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7#iOSGapFixHeight}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari13.prototype._getViewableHeight = function () {
	var viewportHeight = this._getVisualViewportHeight();
	var viewableHeight = viewportHeight + this.iOSGapFixHeight;

	return viewableHeight;
};

/**
 * Uses the browser's VisualViewport API to calculate viewable height excluding the on-screen keyboard.
 * @throws  {error}		Will throw if VisualViewport API is not implemented
 * @returns {number}
 * @private
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari13.prototype._getVisualViewportHeight = function () {
	/** @type {(Object|undefined)} */
	var visualViewport = com.inq.utils.Util.getVisualViewport();

	if (com.inq.utils.Util.isNullOrUndefined(visualViewport)) {
		throw new Error("VisualViewport API is not implemented");
	}

	var scaledHeight = visualViewport.height * visualViewport.scale;
	var roundedScaledHeight = Math.round(scaledHeight);

	return roundedScaledHeight;
};
